import { CourseWriterRow } from "./manageCourseApiSlice";

interface Props {
	students: CourseWriterRow[];
}

export default function PrintStudentPasswordsDocument(props: Props) {
	const getPageSettings = () => {
		return `@page { margin: 40px 50px 40px 50px !important; size: landscape}`;
	};

	return (
		<div>
			<style>{getPageSettings()}</style>
			<section className="grid grid-cols-3 auto-rows-fr">
				{props.students.map((student) => (
					<div
						key={student.userName}
						className="p-4 border border-dashed border-black break-inside-avoid-page">
						<h3 className="pb-2 leading-tight">{student.formalFullName}</h3>
						<p className="line-clamp-3">Username: {student.userName}</p>
						<p>Password: {student.password}</p>
					</div>
				))}
			</section>
		</div>
	);
}
